import type { UnsubscribeReason } from '@/data/models/domain/UnsubscribedContact'
import type { UnsubscribeEmailReasonType } from '@/data/models/domain/UnsubscribedEmailContact'
import type { RequireAtLeastOne } from '@/types'

export enum UnsubscribedRadioValues {
  enabled = 'enabled',
  disabled = 'disabled',
}

export enum UnsubscribedChatSettings {
  close = 'close',
  leaveOpen = 'leaveOpen',
}

export type UnsubscribedSettingsPutBody = {
  sendStopReply: boolean
  sendStopReplyOnManual: boolean
  skipCloseChatAfterUnsubscribe: boolean
  replyTemplateId: number
  autoUnsubscribeAfter: number
}

export type ResubscribeContactPayload =
  | {
      phone: string
      email?: undefined
    }
  | {
      phone?: undefined
      email: string
    }

export type ContactSubscriptionInfoPayload = RequireAtLeastOne<{
  phone: string
  email: string
}>

type ContactSubscriptionInfoItem<T> = null | {
  reason: T
}

export interface ContactSubscriptionInfoResponse {
  email: ContactSubscriptionInfoItem<UnsubscribeEmailReasonType>
  phone: ContactSubscriptionInfoItem<UnsubscribeReason>
}
